import { modules, searchTerms } from '../../constants';
import { officeBreakdownRoute, officeListingsRoute, listingsBreakdownRoute } from '../../market-dynamics/constants/routes';

export const breakdownTabs = {
    OFFICE: 0,
    LISTING_1: 1,
    LISTING_2: 2,
    LISTING_3: 3,
};

export const initialFooterDisabledState = { isFooterDisabled: true };

export const initialCommonTabState = {
    ...initialFooterDisabledState,
    shouldShowAdditionalInfo: false,
};


export const initialListingsBreakdownState = {
    ...initialCommonTabState,
    listingStatus: {
        label: ''
    },
};

export const initialBreakdownsState = Object.freeze({
    selectedBreakdownTab: breakdownTabs.OFFICE,
    tabsByRoute: {
        [officeBreakdownRoute]: {
            [breakdownTabs.OFFICE]: initialCommonTabState,
            [breakdownTabs.LISTING_1]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_2]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_3]: initialListingsBreakdownState,
        },
        [listingsBreakdownRoute]: {
            [breakdownTabs.OFFICE]: initialCommonTabState,
            [breakdownTabs.LISTING_1]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_2]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_3]: initialListingsBreakdownState,
        },
        [officeListingsRoute]: {
            [breakdownTabs.OFFICE]: initialCommonTabState,
            [breakdownTabs.LISTING_1]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_2]: initialListingsBreakdownState,
            [breakdownTabs.LISTING_3]: initialListingsBreakdownState,
        },
    },
});

const persistedMarketDynamicsView = ({
    listingViewId: 'overview',
    breakdowns: initialBreakdownsState,
    listingStatusByView: {}
});

const marketDynamicsView = (initialView) => ({
    ...initialView,
    ...persistedMarketDynamicsView,
    id: modules.marketDynamics.marketDynamics,
    selectedPropTypes: [],
    marketAreaTitle: {
        mainTitle: searchTerms.selectType(searchTerms.marketArea)
    },
    propertyTypeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.propertyTypes)
    },
    priceRangeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.priceRange)
    },
    bedroomsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.bedrooms)
    },
    fullBathroomsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.fullBathrooms)
    },
    lotSizeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.lotSize)
    },
    squareFootageTitle: {
        mainTitle: searchTerms.selectType(searchTerms.squareFootage)
    },
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.marketAreaFilter,
        searchTerms.propTypeFilter,
        searchTerms.timeFrameFilter
    ]
});

export {
    marketDynamicsView
};
